import { ReactNode } from "react";

import { FeatureName } from "@reflag/shared/featureAPI";

export enum DragType {
  FeatureDisplay = "DRAG.FEATURE_DISPLAY",
  MenuReorderOption = "DRAG.MENU_REORDER_OPTION",
}

export type DragTypeItemMap = {
  [DragType.FeatureDisplay]: FeatureName;
  [DragType.MenuReorderOption]: {
    id: string;
    index: number;
    children: ReactNode;
    isChecked: boolean;
  };
};
